import HttpClient from "HttpClient";
import apiRoutes from "Routes/Routes.json";
export const BatchReagentsGetAll = async (payload: any) => {
  const response = await HttpClient().post(
    apiRoutes.Oncology.OncologyBatchReagents.GetReagents,
    payload
  );
  return response;
};

export const BatchReagentsSave = async (payload: any) => {
  const response = await HttpClient().post(
    apiRoutes.Oncology.OncologyBatchReagents.SaveReagents,
    payload
  );
  return response;
};

export const BatchReagentsToggleStatus = async (batchReagentsId: number) => {
  const response = await HttpClient().patch(
    `${apiRoutes.Oncology.OncologyBatchReagents.ToggleReagentStatus}/${batchReagentsId}`
  );
  return response;
};

export const GetBatchReagentLookup = async () => {
  const response = await HttpClient().get(
    `${apiRoutes.Oncology.OncologyBatchReagents.GetBatchReagentLookup}`
  );
  return response;
};
